import { Box } from "@jewlr/storybook/core"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { IS_GE_CHECKOUT, jewlr_t } from "helpers/application"

const PersonalTouch = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>
          Tony Davis Praises Online Retailer Jewlr.com&apos;s Personal Touch
        </SectionTitle>
        <Text>
          <small>
            Originally published 2014/01/03 at{" "}
            <a
              href="https://www.jckonline.com/2014/01/03/tony-davis-praises-online-retailer-jewlrcoms-personal-touch"
              rel="noopener noreferrer"
              target="_blank"
            >
              jckonline.com
            </a>
            .{" "}
          </small>
        </Text>

        <Text>
          &quot;A friendly, risk-free shopping experience&quot; is one of the
          taglines on Jewlr.com, the Toronto-based online retailer specializing
          in
          {jewlr_t("terms.personalized")}zed {jewlr_t("terms.jewelry")}. The
          4-year-old company, which was launched in 2009 by software engineer
          Tony Davis, isn&apos;t just calling out its stellar customer service;
          Jewlr.com is silly with consumer-friendly qualities. Prices for
          merchandise on the site are extremely competitive—a direct result of
          in-house manufacturing that regularly kicks out new styles on 3-D
          printers. The resulting low overhead means Jewlr.com can comfortably
          offer consumers a {IS_GE_CHECKOUT() ? "30" : "99"}-day full-refund
          return policy, even on engraved items. But Davis claims the profitable
          company&apos;s &quot;secret sauce&quot; is the website itself, which
          was designed to be supremely user-friendly while incorporating
          consumer tools that have never existed before. &quot;It&apos;s very
          difficult to sell {jewlr_t("terms.jewelry")}
          online—it&apos;s taken six of us software designers a long time to
          figure it out,&quot; says Davis. &quot;But because we designed the
          site in-house, if we want to change something or try something new, we
          can just do it.&quot;
        </Text>
        <Text>
          <strong>What was the original concept for Jewlr.com?</strong>
        </Text>

        <Text>
          We&apos;re basically Internet entrepreneurs—software guys. I
          didn&apos;t know anything about {jewlr_t("terms.jewelry")} four years
          ago. Nothing. We started it as a test to prove things about
          ­e-commerce marketing. We thought {jewlr_t("terms.personalized")}zed ­
          {jewlr_t("terms.jewelry")} would work really well online. It resonates
          with what is going on in Internet retailing right now. Getting into
          the ­{jewlr_t("terms.jewelry")} industry, it was a big clash of
          cultures for me, coming from the software industry. We were used to
          doing things that moved rapidly and dynamically. So the{" "}
          {jewlr_t("terms.jewelry")} industry was kind of frustrating. I was
          asking for things that people didn&apos;t know how to do—or
          wouldn&apos;t do. I wanted different {jewlr_t("terms.jewelry")} for
          different markets and they would say, &quot;We&apos;ve been doing this
          for 30 years—what do you want us to do?&quot;
        </Text>
        <Text>
          <strong>How did you finally merge the two industries?</strong>
        </Text>
        <Text>
          We started looking at how this stuff gets made, rendered, and
          designed. We started to look at all the 3-D printing and 3-D CAD
          designing. We started taking courses in design. At this point,
          we&apos;re manufacturing in-house, so we can experiment with different
          techniques. We also have outside manufacturers, but all our mass
          production takes place in North America. And we obviously ship
          worldwide.
        </Text>
        <Text>
          <strong>What makes the site so special?</strong>
        </Text>
        <Text>
          The site is very sophisticated. If you&apos;re competing with stores
          like Zales and Wal-Mart, you have to have something different.
          We&apos;re about giving people the freedom to create their own{" "}
          {jewlr_t("terms.jewelry")}. Showing people what they&apos;re getting
          is what makes us [special]. Nameplate necklaces, for example, have
          been available forever. But there&apos;s never been an easy way to see
          what you&apos;re getting in every font; usually a retailer will show
          you one font with [sample] initials. We use 3-D technology that&apos;s
          used in the movie industry, so people can tap their name in and know
          exactly what it&apos;s going to look like in every font. A monogram is
          very difficult to show online; I don’t know anyone else who does it
          like us. We got guys in Sweden to create fonts for us, and we put in
          technology that allows you to sort of futz around with it. Instead of
          spending $1,000 on a necklace that might not look so great, we use
          some innovative technology to show you exactly what you will get. And
          if you&apos;re using a browser like Chrome or Firefox, you can get a
          3-D view of certain pieces.
        </Text>
        <Text>
          <strong>How does 3-D printing enhance your business?</strong>
        </Text>
        <Text>
          Everything we do is designed in 3-D. Regular casting is a multistep
          process, where you develop a model and you have to make a rubber mold
          so you can create waxes. It’s a long and laborious process. With 3-D
          printing, we test and create different models very quickly and easily.
        </Text>
        <Text>
          <strong>What&apos;s next for Jewlr.com?</strong>
        </Text>
        <Text>
          The site is continuously moving. We want to market to people through
          different verticals. Guys like us have the ability to go off into
          small markets. Take yoga ­{jewlr_t("terms.jewelry")}: There are all
          sorts of {jewlr_t("terms.jewelry")} [styles] that go along with
          yoga—poses and symbolic images, chakras. That&apos;s one in maybe 300
          examples of different niche markets that you can go after. That&apos;s
          where online guys have the edge.
        </Text>
      </Box>
    </Section>
  </Box>
)
export default PersonalTouch
